import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {routerActions} from 'react-router-redux';
import { logout } from '../../actions/session';
import {Navbar as NavbarPresentation} from '../presentation/Navbar';

function mapStateToProps(state) {
    return {
        session : state.session
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({...routerActions, logout}, dispatch);
}


class Navbar extends React.Component {
    render() {
        return (
            <NavbarPresentation session={this.props.session} logout={this.props.logout} toggleSidemenu={this.props.toggleSidemenu} />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);


/** WEBPACK FOOTER **
 ** ./src/components/containers/Navbar.jsx
 **/